import { Injectable } from '@angular/core';
import { AppConfig } from '../../app.config';
import { DepartmentService } from './department.service';

@Injectable({
  providedIn: 'root',
})
export class ServicesService {
  selectedService;
  // The service the customer picked on the parent department, kept separately
  // from the location level service so it survives going back a page
  selectedParentService;

  constructor() {}

  async getServices(department) {
    return await department.$getServices();
  }

  async set(service) {
    this.selectedService = service;
  }

  async get() {
    return this.selectedService;
  }

  async setParentService(service) {
    this.selectedParentService = service;
  }

  async getParentService() {
    return this.selectedParentService;
  }

  async getChildServices(service) {
    return await service.$getChildServices();
  }

  // The service is picked on the parent department before the location, so swap
  // it for the equivalent service on the location the customer chose
  async getServiceForLocation(service, location) {
    if (!service || !location) {
      return undefined;
    }
    if (service.company_id === location.id) {
      return service;
    }

    let childServices = [];
    try {
      childServices = await this.getChildServices(service);
    } catch (err) {
      // The service has no children, so fall back to the location's services
      childServices = [];
    }
    const childService = childServices.find(
      (child) => child.company_id === location.id
    );
    if (childService) {
      return childService;
    }

    const locationServices = await this.getServices(location);
    return locationServices.find(
      (locationService) => locationService.name === service.name
    );
  }
}
